import React, { useState } from "react"

import { useSelector } from "react-redux/es/hooks/useSelector"
import { RootState } from "../../../../../../../app/store"
import Stack from "@mui/material/Stack"
import Button from "@mui/material/Button"
import {
  Alert,
  Box,
  CircularProgress,
  LinearProgress,
  Snackbar,
} from "@mui/material"
import Typography from "@mui/material/Typography"
import AttachFileIcon from "@mui/icons-material/AttachFile"

import { useDispatch } from "react-redux/es/hooks/useDispatch"
import FilesList from "./FilesList"
import { IFile } from "../../../../../model/create/CreateInterwiew"
import {
  addFiles,
  newFiles,
  removeFile,
} from "../../../dialogs/model/Interviews"
// import { useUploadFileMutation } from "../../../../../api/InterviewsApi"

const FilesUpload = ({
  setFiles,
  uploading,
  interviewMode,
  setValue,
  interviewRow,
  files,
}: any) => {
  const dispatch = useDispatch()

  const handleFileDownload = (fileUrl: string) => {
    window.open(`http://localhost:3000?fileUrl=${fileUrl}`, "_blank")
  }

  const [snackbarOpen, setSnackbarOpen] = React.useState({
    open: false,
    message: "",
  })

  const handleClose = (
    event: React.SyntheticEvent | Event,
    reason?: string,
  ) => {
    if (reason === "clickaway") {
      return
    }

    setSnackbarOpen({ open: false, message: "" })
  }

  // const [uploadFile] = useUploadFileMutation()

  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const files = event.target.files

    if (files) {
      const allowedExtensions = [
        "docx",
        "odp",
        "rtf",
        "pdf",
        "txt",
        "png",
        "jpeg",
        "jpg",
        "bmp",
        "dib",
        "rle",
      ]

      const fileList: File[] = Array.from(files)

      const invalidFiles = fileList.filter((file) => {
        const extension = file.name.split(".").pop()?.toLowerCase()
        return extension && !allowedExtensions.includes(extension)
      })

      const filesData: IFile[] = fileList.map((file, index) => ({
        id: `${index + 1}.isLocal`,
        name: file.name,
        link: URL.createObjectURL(file),
        size: file.size,
        isCloud: false,
      }))

      dispatch(addFiles(filesData))

      // if (interviewMode === "edit") {
      //   dispatch(addFiles(filesData))

      // }

      if (invalidFiles.length > 0) {
        setSnackbarOpen({
          open: true,
          message:
            "Недопустимый формат файла. Допустимы только файлы с расширениями: DOCX, ODP, RTF, PDF, TXT, PNG, JPEG, BMP, DIB, RLE",
        })
        return
      }

      setFiles((prevFiles: File[]) => [...prevFiles, ...fileList])
    }
  }

  const handleRemoveFile = (file: File) => {
    // Преобразуем тип File в тип IFile
    const fileToRemove: File | undefined = files.find(
      (f: File) => f.name === file.name,
    )

    if (fileToRemove) {
      // Удаление файла из setFiles
      const updatedFiles = files.filter((f: File) => f !== fileToRemove)
      setFiles(updatedFiles)

      // Если файл не в облаке, просто вызовите dispatch(removeFile)
    }
  }

  const selectedFiles = useSelector(
    (state: RootState) => state.interviewRow.personalInformation.file,
  )

  return (
    <Stack spacing={"10px"}>
      <input
        type="file"
        accept=".docx, .odp, .rtf, .pdf, .txt, .png, .jpeg, .bmp, .dib, .rle"
        style={{ display: "none" }}
        id="fileInput"
        multiple
        onChange={handleFileChange}
        value={""}
      />

      <Stack
        sx={{ width: "100%" }}
        direction={"row"}
        spacing={"10px"}
        alignItems={"center"}
      >
        <label htmlFor={uploading ? undefined : "fileInput"}>
          <Box
            sx={{
              backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='4' ry='4' stroke='%231B9C18FF' stroke-width='1' stroke-dasharray='5%2c 5' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`,
              borderRadius: "4px",
              width: "100%",
            }}
          >
            <Button
              component="span"
              size="large"
              sx={{
                height: "48px",
                fontWeight: "bold",
                width: "760px",
                bgcolor: uploading ? "#DCDCDC" : undefined,
              }}
              disabled={uploading}
              fullWidth
              startIcon={uploading ? <></> : <AttachFileIcon />}
            >
              {uploading ? (
                <CircularProgress size={"1.25rem"} />
              ) : (
                <>
                  Прикрепить файл
                  <span
                    style={{
                      color: "rgba(23, 23, 23, 0.7)",
                      marginLeft: "10px",
                      fontWeight: 400,
                    }}
                  >
                    Макс.размер файла:{" "}
                    <span
                      style={{
                        fontWeight: 700,
                        color: "rgba(23, 23, 23, 0.7)",
                      }}
                    >
                      5 MB
                    </span>
                  </span>
                </>
              )}
            </Button>
          </Box>
        </label>
        <Typography
          sx={{
            fontSize: 14,
            width: "230px",
            color: "rgba(23, 23, 23, 0.7)",
          }}
        >
          Форматы:
          <span style={{ fontWeight: "bold", color: "rgba(23, 23, 23, 0.7)" }}>
            DOCX, ODP, RTF, PDF, TXT, PNG, JPEG, bmp, dib, rle
          </span>
        </Typography>
      </Stack>

      <FilesList
        cloud={false}
        flies={selectedFiles}
        handleFileDownload={handleFileDownload}
        handleRemoveFile={handleRemoveFile}
      />
      <Snackbar
        open={snackbarOpen.open}
        autoHideDuration={6000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity="error"
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbarOpen.message}
        </Alert>
      </Snackbar>
    </Stack>
  )
}

export default FilesUpload
